<div class="ui-control ui-inline-control" [formGroup]="formGroup">
  <span class="input-label">{{inputData.label}}</span>
  <p-colorPicker class="input-control" format="hex" [appendTo]="'body'" [formControlName]="inputData.colName"></p-colorPicker>
</div>